// src/api/attendance.js
import API from "../api";

const baseFor = (role) =>
  role === "ADMIN" ? "/admin" : role === "MANAGER" ? "/manager" : "/coach";

/**
 * Returns existing attendance rows for a session.
 * Backend: GET /api/{role}/attendance/by-session/{sessionId}
 */
export const attendanceBySession = (role, sessionId) =>
  API.get(`${baseFor(role)}/attendance/by-session/${sessionId}`);

/**
 * Bulk mark attendance for a session.
 * Backend expects:
 * {
 *   sessionId: number,
 *   rows: [{ studentId, attendanceType, checkinTime?, checkoutTime? }, ...]
 * }
 * Route: POST /api/{role}/attendance/mark
 */
export const markAttendance = (
  role,
  sessionId,
  rows,
  coachId = null,
  sessionNotes = null
) =>
  API.post(`${baseFor(role)}/attendance/mark`, {
    sessionId,
    rows,
    coachId,
    sessionNotes,
  });
